import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetHistoryDetailDTO } from '@/services/history/service/history.repository.interface';
import { GetHistoryDetail } from '@/infrastructure/api-functions/interface/get-history-detail.interface';
import type { HistoryDetail } from '@/services/history/type/history.type';
const NO_PERMISSION_ERROR_CODE = 11120120;
@injectable()
export class GetHistoryDetailDTOImpl implements GetHistoryDetailDTO {
    constructor(
        @inject(GetHistoryDetail)
        private readonly _getHistoryDetailApi: GetHistoryDetail
    ) { }

    async fetch(taskId: string): Promise<HistoryDetail> {
        try {
            const res = await this._getHistoryDetailApi.getHistoryDetail(taskId);
            const detail = res.detail || {};

            return {
                asyncStatus: res.async_status,
                detail: {
                    currentStep: detail.current_step,
                    input: detail.input,
                    keywords: detail.keywords || [],
                    sourceLang: detail.source_lang,
                    targetLang: detail.target_lang,
                    techTopic: detail.tech_topic,
                    content: res.detail.content?.map(item => {
                        return {
                            original: item.src_text,
                            translation: item.translated_text,
                            graphIndex: item.graph_index,
                        }
                    }) || [],
                },
                isRead: res.is_read,
                taskId: res.task_id,
                taskType: res.task_type,
                title: res.title,
                type: res.type,
                updatedAt: res.updated_at,
            };
        } catch (err) {
            if (err.cause?._error_code === NO_PERMISSION_ERROR_CODE) {
                throw new Error('NO_PERMISSION');
            }
        }
    }
}
